import arrayFunction from '../../../general/arrayFunction';
import isEmptyArray from '../../../general/isEmpty/isEmptyArray';
import type { TypeRequestMethod } from '../../../utils/request/types';

import serialize from '../../../general/serialize/serialize';

import * as exModal from '../../../components/modal';
import * as exValidation from '../../validation';
import * as exRequest from '../../../utils/request';

// ----------------------------------------------------------------------------

function request(form: HTMLFormElement, config: Record<string, any> = {}): void {
    // If form is no element form
    if (!(form instanceof HTMLFormElement)) {
        console.error('Is not an element form...');
        return;
    }

    // ------------------------------------------------------------------------

    //
    const src: Record<string, any> = {};

    // Array where callbacks can be placed to be executed before the form is sent
    form.beforeSubmit = [];

    // Array where callbacks can be placed to be executed after the form is sent
    form.afterSubmit = [];

    // Create event (submit)
    form.addEventListener('submit', function (evt: Event): any {
        evt.preventDefault();

        // Get element (form)
        const elForm = evt.currentTarget as HTMLFormElement;

        // If form is locked
        if (src.locked === true) {
            return false;
        }
        // If form is not locked
        else {
            src.locked = true;
        }

        // Get elements (submit)
        const listSubmit = elForm.querySelectorAll('[type=submit]');
        // Set attr disabled
        listSubmit.setAttr('disabled', true);

        // --------------------------------------------------------------------

        // Validation Reset
        exValidation.reset.general(elForm);

        // --------------------------------------------------------------------

        // If there is ckeditor
        if (typeof (window as any).jsckeditor !== 'undefined') {
            // Get elements data ckeditor
            const listEditor = elForm.querySelectorAll<HTMLElement>('textarea[name][data-ckeditor]');
            // Foreach List Editor
            for (const element of listEditor) {
                const elEditor = element as any;

                // CKEditor Instances
                elEditor.value = (window as any).jsckeditor.instances(elEditor.name).getData();
            }
        }

        // --------------------------------------------------------------------

        // If using before submit
        if (elForm.beforeSubmit != null) {
            // Get before submit
            const beforeSubmit = elForm.beforeSubmit;

            // If is function before submit
            if (typeof beforeSubmit === 'function') {
                beforeSubmit(elForm);
            }
            // If is array with function before submit
            else if (isEmptyArray(beforeSubmit)) {
                arrayFunction(beforeSubmit, elForm);
            }
        }

        // --------------------------------------------------------------------

        // Get elements (disabled fields)
        const listDisabledFields = elForm.querySelectorAll('[name]:disabled');
        // Set attr disabled
        listDisabledFields.setAttr('disabled', false);

        // Get upload
        config.upload = config.upload ?? elForm.hasClass('upload');

        // If using function read
        if (typeof config.fnRead === 'function') {
            src.data = config.fnRead(elForm);
        }
        // If using upload
        else if (config.upload === true) {
            src.data = new FormData(elForm);
        }
        // If default
        else {
            src.data = serialize(elForm);
        }

        // Set attr disabled
        listDisabledFields.setAttr('disabled', true);

        // --------------------------------------------------------------------

        // Function Done
        const fnDone = function (data: any): any {
            src.locked = false;

            // Set attr disabled
            listSubmit.setAttr('disabled', false);

            // If using function success
            if (typeof config.fnSuccess === 'function') {
                config.fnSuccess.call(elForm, data);
            }
        };

        // Function Fail
        const fnFail = function (): any {
            src.locked = false;

            // Set attr disabled
            listSubmit.setAttr('disabled', false);

            // If using function error
            if (typeof config.fnError === 'function') {
                config.fnError.call(elForm);
            }
            // Is default
            else {
                // Modal Validation
                exModal.validation({
                    type: 'danger',
                    title: elForm.heading,
                });
            }
        };

        // Request Ajax
        exRequest.ajax({
            method: elForm.method.toUpperCase() as TypeRequestMethod,
            url: elForm.action,
            data: src.data,
            dataType: 'json',
            upload: src.upload,
            fnDone: fnDone,
            fnFail: fnFail,
        });

        // --------------------------------------------------------------------

        // If using after submit
        if (elForm.afterSubmit != null) {
            // Get after submit
            const afterSubmit = elForm.afterSubmit;

            // If is function after submit
            if (typeof afterSubmit === 'function') {
                afterSubmit(elForm);
            }
            // If is array with function after submit
            else if (isEmptyArray(afterSubmit)) {
                arrayFunction(afterSubmit, elForm);
            }
        }
    });
}

// ----------------------------------------------------------------------------

export default request;
